import { AlertTriangle } from "lucide-react";

export const ConfirmDialog = ({ open, title, lines = [], records = [], note, confirmLabel = "Yes", cancelLabel = "No, cancel", danger, onCancel, onConfirm, testId = "confirm-dialog" }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[95] grid place-items-center bg-[#1A2E26]/50 backdrop-blur-sm p-4" data-testid={testId} onClick={onCancel}>
      <div role="dialog" aria-modal="true" className="w-full max-w-md rounded-3xl bg-white shadow-[0_30px_80px_rgba(26,46,38,0.35)] p-7" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3">
          <span className={`grid place-items-center w-11 h-11 rounded-2xl ${danger ? "bg-red-50 text-red-600" : "bg-amber-50 text-amber-600"}`}><AlertTriangle size={22} /></span>
          <h3 className="font-serif text-2xl leading-tight" data-testid={`${testId}-title`}>{title}</h3>
        </div>
        {lines.length > 0 && (
          <div className="mt-4 space-y-1 text-sm" data-testid={`${testId}-message`}>
            {lines.map((l, i) => <p key={i}>{l}</p>)}
          </div>
        )}
        {records.length > 0 && (
          <ol className="mt-3 max-h-48 overflow-auto rounded-xl border border-border bg-muted/30 px-4 py-2 text-xs space-y-0.5 list-decimal list-inside" data-testid={`${testId}-records`}>
            {records.map((r, i) => <li key={i}>{r}</li>)}
          </ol>
        )}
        {note && <p className="mt-3 text-xs text-muted-foreground" data-testid={`${testId}-note`}>{note}</p>}
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" data-testid={`${testId}-cancel`} onClick={onCancel} className="rounded-full border border-border px-5 py-2 text-sm hover:bg-muted transition-colors">{cancelLabel}</button>
          <button type="button" data-testid={`${testId}-yes`} onClick={onConfirm} className={`rounded-full px-5 py-2 text-sm text-white transition-colors ${danger ? "bg-red-600 hover:bg-red-700" : "bg-[#1A2E26] hover:opacity-90"}`}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
};
